import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import Info from "../../ui/widgets/info";
import { ProductContext } from "../../context/product-context/productContext";

export const MembershipReward = (): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { selectedProduct } = useContext(ProductContext);

  return (
    <Info title={getMessage("MembershipReward.Info.title")}>
      {getMessage(`MembershipReward.Info.text.${selectedProduct?.productRef}`)}
    </Info>
  );
};
